// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-selector-with-custom-select__menu {
  margin-top: 0px;
  position: absolute;
  z-index: 2;
  font-size: 14px;
}

.blanket {
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  position: fixed;
  z-index: 1;
}

.dropdown {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ui/ButtonSelectorWithCustomSelect/ButtonSelectorWithCustomSelect.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,MAAM;EACN,QAAQ;EACR,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".button-selector-with-custom-select__menu {\n  margin-top: 0px;\n  position: absolute;\n  z-index: 2;\n  font-size: 14px;\n}\n\n.blanket {\n  bottom: 0;\n  left: 0;\n  top: 0;\n  right: 0;\n  position: fixed;\n  z-index: 1;\n}\n\n.dropdown {\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
